import React from 'react'
import * as RadixDialog from '@radix-ui/react-dialog'
import {twMerge} from 'tailwind-merge'

export const DialogTitle = React.forwardRef


(({className, children, ...props}, ref) => (
  React.createElement(RadixDialog.Title, {
    ref: ref,
    className: twMerge('m-0 text-xl font-semibold', className),
    ...props,}

    , children
  )
))
